import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Pill, Users, Bell, Search, LogOut } from 'lucide-react';
import { APPSETTING } from '../../main';

const CRUMB_MAP: Record<string, string> = {
  '/dashboard':         'Patient Admin',
  '/prescription':      'Prescriptions',
  '/prescriptionadmin': 'Prescription Admin',
  '/appointmentadmin':  'Appointment Admin',
  '/patientadmin':      'Patient Admin',
};

const menuItems = [
  //{ url: 'dashboard',    text: 'Appointments', icon: <Calendar size={16} /> },
  //{ url: 'prescription', text: 'Prescriptions', icon: <Pill size={16} /> },
  { url: 'dashboard',      text: 'Patient Admin',      icon: <Users size={16} /> },

];

const menuItemsAdmin = [
  { url: 'dashboard',      text: 'Patient Admin',      icon: <Users size={16} /> },
  { url: 'prescriptionadmin', text: 'Prescription Admin', icon: <Pill size={16} /> },
];

const AppointmentAppLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const userDataString = localStorage.getItem(APPSETTING.appname + 'user');
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const useremail: string = userData?.user?.email || 'User';
  const initial = useremail[0].toUpperCase();

  const isActive = (url: string) => pathname === `/${url}`;
  const crumb = CRUMB_MAP[pathname] ?? 'Console';

  const handleLogout = () => {
    localStorage.removeItem(APPSETTING.appname + 'user');
    navigate('/login');
  };

  return (
    <div className="dash">
      <aside className="sidebar">
        <div className="side-head">
          {/* Swasthya Reconstructed Text-Logo Mark */}
          <div className="brand" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0px' }}>
            <span className="brand-name" style={{ fontStyle: 'normal', fontWeight: '800', letterSpacing: '0.5px', color: 'var(--ink)' }}>SWASTHYA</span>
            <span style={{ fontSize: '9px', fontStyle: 'italic', color: 'var(--ink-soft)', marginTop: '-2px' }}>Mental Well-being</span>
          </div>
        </div>

        <div className="side-section-label">WORKSPACE</div>

        <nav className="side-nav">
          {window.APPUSER?.user?.usertype === 'admin' && menuItemsAdmin.map((item) => (
            <button
              key={item.url}
              className={'nav-item' + (isActive(item.url) ? ' is-active' : '')}
              onClick={() => navigate('/' + item.url)}
            >
              <span className="nav-ico">{item.icon}</span>
              <span>{item.text}</span>
              {isActive(item.url) && <span className="nav-dot" />}
            </button>
          ))}
          {window.APPUSER?.user?.usertype !== 'admin' && menuItems.map((item) => (
            <button
              key={item.url}
              className={'nav-item' + (isActive(item.url) ? ' is-active' : '')}
              onClick={() => navigate('/' + item.url)}
            >
              <span className="nav-ico">{item.icon}</span>
              <span>{item.text}</span>
              {isActive(item.url) && <span className="nav-dot" />}
            </button>
          ))}
        </nav>

        <div className="side-foot">
          <button className="nav-item subtle" onClick={handleLogout}>
            <span className="nav-ico"><LogOut size={16} /></span>
            <span>Sign out</span>
          </button>
        </div>
      </aside>

      <div className="dash-main">
        <header className="topbar">
          <div className="crumbs">
            Clinic console <span>›</span> {crumb}
          </div>
          <div className="top-tools">
            <div className="search">
              <span className="search-ico"><Search size={14} /></span>
              <input placeholder="Search patients, visits..." />
            </div>
            <button className="icon-btn ring" aria-label="Notifications">
              <Bell size={16} />
              <span className="bell-dot" />
            </button>
            <div className="avatar-wrap">
              <button
                className="avatar"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                {initial}
              </button>
              {showProfileMenu && (
                <div className="avatar-menu">
                  <div className="am-head">
                    <div className="avatar sm">{initial}</div>
                    <div>
                      <strong>{useremail}</strong>
                      <span>Clinic staff</span>
                    </div>
                  </div>
                  <button className="am-item danger" onClick={handleLogout}>
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        <div className="dash-scroll">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppointmentAppLayout;